import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/** Scrolls to top on every route PUSH/REPLACE; back/forward keep native restoration. */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, navType]);

  return null;
};
